// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   */
  id: string;
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string | null;
  /**
   *
   */
  deleted?: boolean;
  /**
   *
   */
  apiKey?: boolean;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function UserFromJSON(json: any): User {
  return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
    deleted: json["deleted"] == null ? undefined : json["deleted"],
    apiKey: json["api_key"] == null ? undefined : json["api_key"],
  };
}

export function UserToJSON(json: any): User {
  return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
    deleted: value["deleted"],
    api_key: value["apiKey"],
  };
}
